export enum BorderColor {
  gray = 'border-b-gray-cc',
  black = 'border-b-gray-22',
  light_gray = 'border-b-gray-ea',
}
